module.exports = __webpack_public_path__ + "media/images/illustrations/wrapped_packed_items-034e53446fd0cdf57867020ec750953c.svg";